var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 355.343,
    height: 306,
    viewBox: "0 0 355.343 306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1430",
    "data-name": "Group 1430",
    transform: "translate(-240.895 -204.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1228",
    "data-name": "Group 1228",
    transform: "translate(7.672 -113.25)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 153,
    cy: 153,
    r: 153,
    transform: "translate(263.276 317.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M2.681,9.8l-.018,0L0,0,6.181.895A4.482,4.482,0,0,1,8.253.38a4.758,4.758,0,0,1,3.169,1.274l2.561.371V8.106h0c-.035,4.178-2.587,7.552-5.73,7.552C5.548,15.658,3.281,13.158,2.681,9.8Z",
    transform: "translate(344.291 410.527)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(437 318)",
    fill: "#0e55e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(474.59 240.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M515.331,350.529a53.736,53.736,0,0,0,7.178-19.972l2.182.32,4.308.633.056,0a60.16,60.16,0,0,0-1.132-23.4l-6.409,1.588a53.752,53.752,0,0,0-9.067-19.186l5.313-3.949A59.905,59.905,0,0,0,500.415,270.8l-3.422,5.675a53.637,53.637,0,0,0-19.972-7.178l.958-6.546a60.546,60.546,0,0,0-23.4,1.132l1.588,6.409a53.757,53.757,0,0,0-19.186,9.066l-3.948-5.313a59.917,59.917,0,0,0-15.765,17.344l5.675,3.422a53.644,53.644,0,0,0-7.178,19.972l-4.63-.682-1.894-.262-.021-.013a60.558,60.558,0,0,0,1.131,23.4l6.41-1.587a53.855,53.855,0,0,0,9.087,19.2l-5.312,3.949a59.786,59.786,0,0,0,17.323,15.752l3.422-5.675a53.775,53.775,0,0,0,19.993,7.191l-.752,5.086-.206,1.459a60.433,60.433,0,0,0,23.378-1.144l-1.587-6.409a54.319,54.319,0,0,0,19.221-9.075l3.948,5.312a60.237,60.237,0,0,0,15.73-17.336Zm-61.322-2.771a29.281,29.281,0,1,1,40.192-9.971A29.279,29.279,0,0,1,454.009,347.758Z",
    transform: "translate(-408.57 -262.106)",
    fill: "none",
    stroke: "#e0e0e0",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1326",
    "data-name": "Group 1326",
    transform: "translate(225.578 142.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(65.695 80.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1312",
    "data-name": "Group 1312",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1309",
    "data-name": "Group 1309",
    transform: "translate(0 70.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M332.713,335.835H85.75L71.023,168.31H317.987Z",
    transform: "translate(-66.666 -168.31)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M80.414,341.171l4.364-5.336L70.051,168.31l-4.357,5.418Z",
    transform: "translate(-65.695 -168.31)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M90,330.327,76.432,176.01a2.783,2.783,0,0,1,2.771-3.025H312.936a2.783,2.783,0,0,1,2.771,2.538L329.273,329.84a2.782,2.782,0,0,1-2.771,3.025H92.768A2.783,2.783,0,0,1,90,330.327Z",
    transform: "translate(-67.651 -169.163)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M122.6,373.195H85.392l-2.632,7.526H119.97Z",
    transform: "translate(-68.807 -205.67)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M130.9,373.195H375.56l-2.632,7.526H128.268Z",
    transform: "translate(-77.105 -205.67)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M254.59,373.195h46.9l-.5,4.927h-46.9Z",
    transform: "translate(-100.047 -205.67)",
    fill: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1311",
    "data-name": "Group 1311",
    transform: "translate(99.305 112.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M252.155,284.19h52.563a51.254,51.254,0,0,1,.264,13.6,45.887,45.887,0,0,1-3.337,12.677Z",
    transform: "translate(-199 -231.627)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M252.155,272.646l1.308-51.765a63.253,63.253,0,0,1,33.853,17.978,61.7,61.7,0,0,1,17.4,33.787Z",
    transform: "translate(-199 -220.083)",
    fill: "#e9eaeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M240.3,272.468l-46.677,17.978a58.435,58.435,0,0,1-5.885-17.978c-4.356-28.835,15.788-52.563,44.623-52.563a54.722,54.722,0,0,1,9.248.8Z",
    transform: "translate(-187.145 -219.905)",
    fill: "#eef0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M241.745,284.19l49.49,26.281c-6.924,16.244-22.8,26.282-41.551,26.282-22.046,0-43.948-13.869-54.617-34.585Z",
    transform: "translate(-188.59 -231.627)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Setup_analytics",
    "data-name": "Setup analytics",
    transform: "translate(72.365 73.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1325",
    "data-name": "Group 1325",
    transform: "translate(1 13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1315",
    "data-name": "Group 1315",
    transform: "translate(49.42 72.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1313",
    "data-name": "Group 1313"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M221.282,225.5h-73.65a9.419,9.419,0,0,1-9.19-8.5l-3.687-45.287a7.738,7.738,0,0,1,7.807-8.5h73.65a9.418,9.418,0,0,1,9.19,8.5L229.088,217A7.738,7.738,0,0,1,221.282,225.5Z",
    transform: "translate(-134.372 -162.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M221.2,225.772h-73.65a9.76,9.76,0,0,1-9.543-8.822l-3.687-45.286a8.092,8.092,0,0,1,8.159-8.881h73.65a9.762,9.762,0,0,1,9.543,8.823l3.687,45.287a8.091,8.091,0,0,1-8.159,8.88Zm-78.72-62.282a7.385,7.385,0,0,0-7.454,8.116l3.687,45.287a9.041,9.041,0,0,0,8.837,8.172H221.2a7.384,7.384,0,0,0,7.454-8.115l-3.688-45.286a9.04,9.04,0,0,0-8.836-8.174Z",
    transform: "translate(-134.294 -162.782)",
    fill: "#f90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1314",
    "data-name": "Group 1314",
    transform: "translate(22.178 6.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M213.454,215.225a22.834,22.834,0,0,1-10.825,6.558l-1.219-3.491A19.677,19.677,0,0,0,215.8,197.308a23.641,23.641,0,0,0-7.61-15.36l2.348-2.557C221.167,189.221,222.483,205.4,213.454,215.225Z",
    transform: "translate(-168.71 -171.969)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M204.581,177.736l-2.348,2.557a23.491,23.491,0,0,0-15.878-6.36A19.906,19.906,0,0,0,171.52,180.3l-2.773-2.563a23.335,23.335,0,0,1,17.313-7.422A27.476,27.476,0,0,1,204.581,177.736Z",
    transform: "translate(-162.754 -170.314)",
    fill: "#333f50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M195.337,221.782c-8.542,2.337-18.094-.169-25.009-6.558-10.622-9.829-11.939-26-2.917-35.834l2.773,2.563a20.051,20.051,0,0,0-5.11,15.354,23.994,23.994,0,0,0,23.481,21.713,21.273,21.273,0,0,0,5.563-.73Z",
    transform: "translate(-161.417 -171.969)",
    fill: "#f90"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1316",
    "data-name": "Group 1316",
    transform: "translate(0 2.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M160.841,139.4H87.191a9.419,9.419,0,0,1-9.19-8.5L74.314,85.62a7.738,7.738,0,0,1,7.806-8.5h73.651a9.418,9.418,0,0,1,9.19,8.5l3.687,45.286A7.739,7.739,0,0,1,160.841,139.4Z",
    transform: "translate(-73.932 -76.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M160.762,139.679H87.111a9.761,9.761,0,0,1-9.542-8.824L73.882,85.57a8.091,8.091,0,0,1,8.159-8.881h73.65a9.762,9.762,0,0,1,9.544,8.822l3.687,45.287a8.093,8.093,0,0,1-8.159,8.881ZM82.041,77.4a7.384,7.384,0,0,0-7.453,8.115L78.275,130.8a9.04,9.04,0,0,0,8.836,8.173h73.651a7.383,7.383,0,0,0,7.453-8.116L164.529,85.57a9.042,9.042,0,0,0-8.838-8.173Z",
    transform: "translate(-73.853 -76.689)",
    fill: "#f90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317",
    transform: "translate(6.729 11.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M82.4,92.154h39.028l-.314-3.856H82.083Z",
    transform: "translate(-82.083 -88.299)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M169.157,92.154H130.129l-.314-3.856h39.028Z",
    transform: "translate(-90.786 -88.299)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M83.4,104.43H94.53l-.314-3.856H83.082Z",
    transform: "translate(-82.265 -90.537)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M163.936,104.43H97.013l-.314-3.856h66.923Z",
    transform: "translate(-84.748 -90.537)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M84.4,116.705h34.74l-.314-3.856H84.081Z",
    transform: "translate(-82.447 -92.776)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M170.2,116.705H126.883l-.314-3.856h43.317Z",
    transform: "translate(-90.195 -92.776)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M85.395,128.981h59.29l-.314-3.856H85.081Z",
    transform: "translate(-82.629 -95.014)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M176.674,128.981H157.907l-.314-3.856H176.36Z",
    transform: "translate(-95.852 -95.014)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M86.394,141.257h27.422L113.5,137.4H86.08Z",
    transform: "translate(-82.812 -97.252)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M170.566,141.257H119.932l-.314-3.856h50.635Z",
    transform: "translate(-88.927 -97.252)",
    fill: "#f90"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321",
    transform: "translate(100.684 2.453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M283.978,139.4h-73.65a9.418,9.418,0,0,1-9.19-8.5L197.452,85.62a7.737,7.737,0,0,1,7.806-8.5h73.65a9.418,9.418,0,0,1,9.19,8.5l3.687,45.286A7.738,7.738,0,0,1,283.978,139.4Z",
    transform: "translate(-197.069 -76.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M283.9,139.679h-73.65a9.762,9.762,0,0,1-9.543-8.824L197.019,85.57a8.091,8.091,0,0,1,8.159-8.881h73.651a9.76,9.76,0,0,1,9.543,8.822l3.687,45.287a8.093,8.093,0,0,1-8.159,8.881ZM205.178,77.4a7.384,7.384,0,0,0-7.453,8.115l3.687,45.287a9.041,9.041,0,0,0,8.837,8.173H283.9a7.384,7.384,0,0,0,7.453-8.116L287.666,85.57a9.041,9.041,0,0,0-8.837-8.173Z",
    transform: "translate(-196.99 -76.689)",
    fill: "#f90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320",
    transform: "translate(9.923 9.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M257.04,132.3h-1.3l-3.582-44h1.3Z",
    transform: "translate(-216.972 -88.299)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M258.387,115.919h-8.2l-1.4-17.193h8.2Z",
    transform: "translate(-216.357 -90.2)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M237.3,132.3H236l-3.582-44h1.3Z",
    transform: "translate(-213.372 -88.299)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M239.063,121.062h-8.2l-1.227-15.071h8.2Z",
    transform: "translate(-212.865 -91.525)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M217.553,132.3h-1.3l-3.582-44h1.3Z",
    transform: "translate(-209.772 -88.299)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M218.171,106.952h-8.2L209.126,96.6h8.2Z",
    transform: "translate(-209.126 -89.813)",
    fill: "#333f50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M276.783,132.3h-1.3l-3.582-44h1.3Z",
    transform: "translate(-220.572 -88.299)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M278.925,125.678h-8.2l-2.194-26.952h8.2Z",
    transform: "translate(-219.958 -90.2)",
    fill: "#333f50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M296.526,132.3h-1.3l-3.582-44h1.3Z",
    transform: "translate(-224.173 -88.299)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M299.088,130.825h-8.2l-1.757-21.585h8.2Z",
    transform: "translate(-223.714 -92.117)",
    fill: "#f90"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1324",
    "data-name": "Group 1324",
    transform: "translate(21.868 142.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1322",
    "data-name": "Group 1322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M187.586,310.882h-73.65a9.418,9.418,0,0,1-9.19-8.5L101.059,257.1a7.738,7.738,0,0,1,7.807-8.5h73.65a9.418,9.418,0,0,1,9.19,8.5l3.687,45.287A7.738,7.738,0,0,1,187.586,310.882Z",
    transform: "translate(-100.677 -248.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M187.507,311.157h-73.65a9.76,9.76,0,0,1-9.543-8.823l-3.687-45.287a8.092,8.092,0,0,1,8.159-8.881h73.65a9.762,9.762,0,0,1,9.543,8.823l3.687,45.287a8.09,8.09,0,0,1-8.159,8.88Zm-78.72-62.282a7.386,7.386,0,0,0-7.454,8.116l3.687,45.287a9.042,9.042,0,0,0,8.837,8.172h73.65a7.386,7.386,0,0,0,7.453-8.115l-3.686-45.287a9.041,9.041,0,0,0-8.837-8.173Z",
    transform: "translate(-100.598 -248.167)",
    fill: "#f90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1323",
    "data-name": "Group 1323",
    transform: "translate(13.963 9.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M121.865,283.192l15.874,18.34,18.2-28.08,11.257,14.51,2.747-4.237,18.4,22.053-70.672-.026Z",
    transform: "translate(-117.675 -262.766)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M174.857,281.947l-7.377,15.8-23.531-37.362-11.08,23.727-3.551-5.638L117.677,303.4l70.667-.035Z",
    transform: "translate(-117.675 -260.383)",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(322.422 260.146)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(211.422 183.146)",
    fill: "#f90"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M3628.842-1457.933h19.481l-6.352-77.635-57.329.239-13.439-.239-54.781.239",
    transform: "translate(-3076.458 1863.933)",
    fill: "none",
    stroke: "#fd9827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: "1 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M3341.722-1582.538l-1.163-8.613H3239.395l20.158,181.014,60.1-2.111",
    transform: "translate(-2998 1816.046)",
    fill: "none",
    stroke: "#fd9926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1,
    strokeDasharray: "1 2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(319 400)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295",
    transform: "translate(241.395 468.96)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x2: 324.137,
    y2: 0.54,
    transform: "translate(21.968)",
    fill: "none",
    stroke: "#8c8c8c",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M0,0H11.391",
    fill: "#333f4f",
    stroke: "#8c8c8c",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin1);
export default __webpack_public_path__ + "static/media/login-1.cdf276cabff182cb5645cf86aea12d88.svg";
export { ForwardRef as ReactComponent };